import HlsVideoPlayer from './HlsVideoPlayer';

export default HlsVideoPlayer;
